function isFactoryProvider(value) {
  return value instanceof Function;
}
function getProviderKey(value) {
  return isFactoryProvider(value) ? 'useFactory' : 'useValue';
}
function getProviderKeyByType(type) {
  return type === 'value' ? 'useValue' : 'useFactory';
}

/**
 * Generated bundle index. Do not edit.
 */

export { getProviderKey, getProviderKeyByType, isFactoryProvider };
